module.exports = __webpack_public_path__ + "img/sak-background.9010eff6.png";